import { Channel } from '#app/typings/channel';
import { OrderClientState } from '#app/typings/orderClient';

export enum DisputeType {
  OUT_OF_STOCK = 'out_of_stock',
  RETURN_TO_SENDER = 'return_to_sender',
  RETRACTION = 'retraction',
  PRODUCT_RETRACTION = 'product_retraction',
  PACKAGE_DAMAGED = 'package_damaged',
  PRODUCT_DAMAGED = 'product_damaged',
  NON_COMPLIANT_PRODUCT = 'non_compliant_product',
  PACKAGE_LOST = 'package_lost',
  MISSING_PRODUCT = 'missing_product',
  WRONG_ITEM = 'wrong_item',
  ORDER_CANCELLATION = 'order_cancellation',
  SHIPPING_FEES = 'shipping_fees',
  PROMO_CODE = 'promo_code',
  BUG_LABEL = 'bug_label',
  OTHER = 'other',
}

export const DisputeTypeTranslations: Record<DisputeType, string> = {
  [DisputeType.OUT_OF_STOCK]: 'Rupture de stock',
  [DisputeType.RETURN_TO_SENDER]: 'Retour expéditeur',
  [DisputeType.RETRACTION]: 'Rétractation',
  [DisputeType.PRODUCT_RETRACTION]: 'Rétractation Produit',
  [DisputeType.PACKAGE_DAMAGED]: 'Colis cassé',
  [DisputeType.PRODUCT_DAMAGED]: 'Produit cassé',
  [DisputeType.NON_COMPLIANT_PRODUCT]: 'Produit non conforme',
  [DisputeType.PACKAGE_LOST]: 'Colis perdu',
  [DisputeType.MISSING_PRODUCT]: 'Produit manquant',
  [DisputeType.WRONG_ITEM]: 'Erreur article',
  [DisputeType.ORDER_CANCELLATION]: 'Annulation commande',
  [DisputeType.SHIPPING_FEES]: 'Frais de port',
  [DisputeType.PROMO_CODE]: 'Code promo',
  [DisputeType.BUG_LABEL]: 'Bug étiquette',
  [DisputeType.OTHER]: 'Autre',
};

export const DisputeTypeSelects = (Object.keys(DisputeTypeTranslations) as DisputeType[]).map((disputeType) => ({
  value: disputeType,
  label: DisputeTypeTranslations[disputeType],
}));

export enum DisputeState {
  PENDING_PROCESSING = 'pending_processing',
  PROCESSING = 'processing',
  CLOSED = 'closed',
  ARCHIVED = 'archived',
}

export const DisputeStateTranslations: Record<DisputeState, string> = {
  [DisputeState.PENDING_PROCESSING]: 'En attente traitement',
  [DisputeState.PROCESSING]: 'Traitement en cours',
  [DisputeState.CLOSED]: 'Clôturé',
  [DisputeState.ARCHIVED]: 'Archivé',
};

export const DisputeStateSelects = (Object.keys(DisputeStateTranslations) as DisputeState[]).map((disputeState) => ({
  value: disputeState,
  label: DisputeStateTranslations[disputeState],
}));

export type DisputeList = {
  uuid: string;
  ref?: string;
  litigeAt: string;
  authorLitige: {
    name: string;
  };
  orderClient: {
    number: string;
    createdAt: string;
    client: {
      name: string;
      email: string;
    };
    channel: Channel;
    orderClientState: OrderClientState;
    orderClientCarrier: {
      label: string;
    };
  };
  type: DisputeType;
  state: DisputeState;
};

export type DisputeListByClient = {
  uuid: string;
  ref?: string;
  litigeAt: string;
  authorLitige: {
    name: string;
  };
  type: DisputeType;
  state: DisputeState;
};

export type DisputeListRefund = {
  uuid: string;
  orderClientUuid: string;
  number: string;
  email: string;
  client: string;
  channel: string;
  state: string;
  type: DisputeType;
  createdAt: string;
  litigeAt: string;
  priceHT: number;
  priceTTC: number;
  authorAsking: string;
  askingAt: string;
  author: string;
  dealAt: string;
};

export type DisputeItem = {
  ref: string;
  reason: string;
  createdAt: string;
  dealAt?: string;
  authorLitige: { name: string };
  authorLitigeReturn?: { name: string };
  returnAt?: string;
  orderClient: {
    uuid: string;
    number: string;
    numberSylius?: string;
    canRefundCarrier: boolean;
    canRefundPayment: boolean;
    orderClientForwarding?: {
      uuid: string;
      number: string;
    };
    orderClientCarrier?: {
      label: string;
      priceTTC: number;
      carrier: number;
    };
    orderClientAddressBilling?: {
      firstname: string;
      lastname: string;
      address1: string;
      address2?: string;
      city: string;
      zipCode: string;
      countryCode: string;
      company?: string;
      phone?: string;
    };
    orderClientAddressShipping?: {
      firstname: string;
      lastname: string;
      address1: string;
      address2?: string;
      city: string;
      zipCode: string;
      countryCode: string;
      company?: string;
      phone?: string;
    };
  };
  type: DisputeType;
  state: DisputeState;
  commentReturn?: string;
  commentClosing?: string;
  authorClosing?: { name: string };
  authorForwarding?: { name: string };
  forwardingAt?: string;
  authorRefundAsking: { name: string };
  refundAskingAt: string;
  fromEntrepot: boolean;
  repaidOrForwardingLegit: boolean;
  authorRepaid?: { name: string };
  repaidAt?: string;
  amountToRefund: number;
};
